import { graphql } from 'app/generated/gql'
import { gqlQuery } from 'app/lib/graphqlClient'

const TAG_VALUES_QUERY = graphql(`
  query TagValues($entity: String!, $search: String) {
    tagValues(entity: $entity, search: $search)
  }
`)

export async function tagValuesFetcher(
  entity: string,
  params: { query: string; [key: string]: string },
): Promise<string[]> {
  const result = await gqlQuery<{ tagValues: string[] }>(TAG_VALUES_QUERY, {
    entity,
    search: params.query || undefined,
  })
  return result.data?.tagValues ?? []
}
